import * as React from 'react';

export interface IDxgMenuUIProps {
    totalPerMonthPrice?: number;
    totalPrice?: number;
    hasUndefinedPrice?: boolean;
}

const getUiDisplayText = (props: IDxgMenuUIProps): string => {
    if (props.hasUndefinedPrice) {
        return 'See Dealer';
    }

    if (props.totalPerMonthPrice !== undefined && props.totalPerMonthPrice !== null) {
        return `$${props.totalPerMonthPrice}/mo`;
    }

    return `$${props.totalPrice}`;
};

const DxgMenuSummaryUI: React.FC<IDxgMenuUIProps> = (props) => {
    return (
        <>
            <p>{getUiDisplayText(props)}</p>
        </>
    );
};

export default DxgMenuSummaryUI;
